module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LW4bvc/tc-custom/9781681883182.jpg?1699523190611",
      "alt": "This image is the cover for the book Dish of the Day"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dish of the Day\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Cook seasonally with this year’s-worth of recipes for soups, salads, desserts, and one pot, vegetable, and healthy dishes.")]), _c('br'), _c('br'), _vm._v("From the bestselling Williams Sonoma "), _c('i', [_vm._v("Of The Day")]), _vm._v(" series, comes a compilation of 365 favorite recipes, ranging from soups, salads, desserts, and one pot, vegetable, and healthy dishes. Find inspiration for cooking any day of the year in this indispensable collection. This colorful, calendar-style cookbook offers ideas to match any season, occasion, or mood. Organized by date, this book can be used as a guide to eating seasonally throughout the year. Stunning photographs and a colorful graphic design add visual appeal to the enticing cookbook.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kate McMillan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kate McMillan is chef and owner of an eponymous catering company and is an instructor at Tante Marie’s Cooking School in San Francisco. Kate has worked as an event planner for Vogue and Glamour magazines. She lives in the San Francisco Bay Area with her husband and three young daughters.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Weldonowen\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0